import type { TranslationKeys } from "@/hooks/useTranslation/catalogs"
import type { BillingPlanId } from "@/services/api/billingService"

export const PLAN_COPY: Record<
  BillingPlanId,
  {
    name: TranslationKeys
    features: readonly [TranslationKeys, TranslationKeys, TranslationKeys]
  }
> = {
  starter: {
    name: "UPGRADE/PLAN_STARTER",
    features: [
      "UPGRADE/PLAN_STARTER_CREDITS",
      "UPGRADE/PLAN_FEATURE_TOOLS",
      "UPGRADE/PLAN_SEATS",
    ],
  },
  pro: {
    name: "UPGRADE/PLAN_PRO",
    features: [
      "UPGRADE/PLAN_PRO_CREDITS",
      "UPGRADE/PLAN_FEATURE_TOOLS",
      "UPGRADE/PLAN_SEATS",
    ],
  },
}
